<template>
  <div class="container-view">
    <Breadcrumbs />

    <div class="row col-12">
      <div class="col-12">
        <Listado :dataGrupos="dataGrupos" :isLoading="isLoading" />
      </div>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Listado from '../components/Listado.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    Listado,
    Breadcrumbs
  },
  mixins: [Message, Validation],
  data: function () {
    return {
      dataGrupos: [],
      isLoading: false
    };
  },
  mounted () {
    this._callData();
  },
  methods: {
    async _callData () {
      this.isLoading = true;

      let request = {
        controller: '/Ambito'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.dataGrupos = response.data;
          this.isLoading = false;
        })
        .catch(err => {
          this.showError(err);
          this.isLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
